import { enableNewCheckoutForFeature } from "constants/constants";

export default function enableNewCheckoutForChannel(channelDetails) {
  if (channelDetails.is_whatsapp) {
    return enableNewCheckoutForFeature.whatsapp_channel;
  } else if (channelDetails.is_telegram) {
    return enableNewCheckoutForFeature.telegram_channel;
  } else return enableNewCheckoutForFeature.regular_channel;
}
